import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import React, { createContext, useEffect, useState } from 'react';
import { useAuthStateChange, useClient } from 'react-supabase';
import { useOrg } from '../hooks/useOrg';
export var Context = createContext(undefined);
export var Provider = function Provider(_ref) {
  var children = _ref.children;
  var supabase = useClient();

  var _useState = useState(supabase.auth.user()),
      user = _useState[0],
      setUser = _useState[1];

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId;

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(user) {
      var _yield$supabase$from$, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return supabase.from('squeak_profiles_readonly').select('squeak_profiles!profiles_readonly_profile_id_fkey!inner(avatar, first_name, last_name, id, metadata:squeak_profiles_readonly(role))').match({
                user_id: user === null || user === void 0 ? void 0 : user.id,
                organization_id: organizationId
              }).single();

            case 2:
              _yield$supabase$from$ = _context.sent;
              data = _yield$supabase$from$.data;
              return _context.abrupt("return", data === null || data === void 0 ? void 0 : data.squeak_profiles);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useAuthStateChange( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, session) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setUser(session === null || session === void 0 ? void 0 : session.user);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }());
  useEffect(function () {
    if (user && !(user === null || user === void 0 ? void 0 : user.profile)) {
      getProfile(user).then(function (profile) {
        var userMetadata = profile === null || profile === void 0 ? void 0 : profile.metadata[0];
        var isModerator = (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.role) === 'admin' || (userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.role) === 'moderator';

        if (profile) {
          setUser(_extends({}, user, {
            profile: profile,
            isModerator: isModerator
          }));
        }
      });
    }
  }, [user]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: user
  }, children);
};